import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from "moment";
import { SET_DOCUMENTS, SET_DOCUMENT_COMMENTS, SET_DOCUMENT_CLASSIFICATIONS, ADD_DOCUMENT_COMMENT, REMOVE_DOCUMENT_COMMENT, ADD_DOCUMENTS_TO_CLASSIFICATION, SET_CLIENT_DETAILS } from "./guest-upload-mutations";
import { updatePin, verifyPin, getDocuments, downloadSampleDocument, markUploadCompleted, sendComment, createSignedUrls } from "../api/guest-upload-api";
import { v4 as uuidv4 } from "uuid";
import { normalize } from "normalizr";
import { classificationListSchema } from "./guest-upload-schema";
import Err from "@Client/@Routes/error";
import { putS3Data } from "@Shared/utils/ajax";
import { showToast } from "@Shared/utils/constants";
import isPDFEncrypted from "@Shared/utils/is-pdf-encrypted";
import { decodeToken } from "@Shared/@Utils/utils";
import Amplitude from "@Shared/@Utils/amplitude";
import { groupBy, isEmpty } from "lodash";
export const LOAD_DOCUMENTS = "LOAD_DOCUMENTS";
export const DOWNLOAD_SAMPLE_DOCUMENT = "DOWNLOAD_SAMPLE_DOCUMENT";
export const SEND_DOCUMENT_COMMENT = "SEND_DOCUMENT_COMMENT";
export const UPLOAD_DOCUMENT_TO_CLASSIFICATION = "UPLOAD_DOCUMENT_TO_CLASSIFICATION";
export const VERIFY_PIN = "VERIFY_PIN";
export const UPDATE_PIN = "UPDATE_PIN";
const actions = {
  [VERIFY_PIN]: async (context, {
    code
  }) => {
    try {
      const {
        token
      } = context.state;
      const {
        forceChange,
        familyName,
        givenName
      } = await verifyPin(token, code);
      const {
        client: clientUsername
      } = decodeToken(token);
      context.commit(SET_CLIENT_DETAILS, {
        clientDetails: {
          clientUsername,
          familyName,
          givenName
        }
      });
      Amplitude.logEvent("Guest Upload - pin verified");
      return {
        forceChange
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_PIN]: async (context, {
    code,
    newCode
  }) => {
    try {
      const {
        token
      } = context.state;
      await updatePin(token, code, newCode);
      Amplitude.logEvent("Guest Upload - pin updated");
      return true;
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_DOCUMENTS]: async context => {
    try {
      const {
        token
      } = context.state;
      const {
        documents: documentClassifications
      } = await getDocuments(token);
      const {
        entities: {
          classifications,
          comments,
          documents
        },
        result
      } = normalize(documentClassifications, [classificationListSchema]);
      context.commit(SET_DOCUMENTS, {
        documents: {
          byId: documents || {}
        }
      });
      context.commit(SET_DOCUMENT_COMMENTS, {
        comments: {
          byId: comments || {}
        }
      });
      context.commit(SET_DOCUMENT_CLASSIFICATIONS, {
        classifications: {
          byId: classifications || {},
          allIds: result || []
        }
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_SAMPLE_DOCUMENT]: async (context, {
    documentId
  }) => {
    try {
      const {
        token
      } = context.state;
      const {
        url
      } = await downloadSampleDocument(token, documentId);
      return {
        url
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [SEND_DOCUMENT_COMMENT]: async (context, {
    documentId,
    comment,
    senderDetails
  }) => {
    const tempId = moment().unix().toString();
    try {
      const {
        token
      } = context.state;
      const createdAt = moment().format();
      context.commit(ADD_DOCUMENT_COMMENT, {
        comment: _objectSpread({
          id: tempId,
          createdAt,
          comment
        }, senderDetails),
        documentId
      });
      await sendComment(token, documentId, comment);
      Amplitude.logEvent("Guest Upload - comment added to document", {
        data: {
          document: documentId
        }
      });
    } catch (e) {
      context.commit(REMOVE_DOCUMENT_COMMENT, {
        documentId,
        commentId: tempId
      });
      Err.handle(e);
    }
  },
  [UPLOAD_DOCUMENT_TO_CLASSIFICATION]: async (context, {
    classification,
    files,
    fileName,
    notifyUser = true
  }) => {
    try {
      const {
        token
      } = context.state;
      const newDocuments = [];
      const filesData = [];
      for (const file of files) {
        var _context;
        const name = fileName || _replaceAllInstanceProperty(_context = file.name).call(_context, " ", "-");
        filesData.push({
          fileName: name,
          data: file,
          type: file.type,
          url: "",
          documentId: uuidv4()
        });
      }
      const filesInfo = _mapInstanceProperty(filesData).call(filesData, file => ({
        fileName: file.fileName,
        type: file.type,
        size: file.data.size,
        documentId: file.documentId
      }));
      const groupedFilesData = groupBy(filesData, "documentId");
      const signedUrls = await createSignedUrls(filesInfo, token, classification.documentRequestId);
      for (const {
        url,
        documentId
      } of signedUrls) {
        if (!isEmpty(groupedFilesData[documentId]) && !isEmpty(groupedFilesData[documentId][0])) {
          groupedFilesData[documentId][0].url = url;
        }
      }
      for (const file of filesData) {
        var _file$fileName, _context2;
        let isEncrypted = false;
        const extension = (_file$fileName = file.fileName) == null ? void 0 : _file$fileName.split(".").pop();
        if (extension === "pdf" || file.type === "application/pdf") {
          const PDFEncrypted = await isPDFEncrypted(file.data);
          if (PDFEncrypted) {
            showToast("info", `fileIsProtected|{filename:${file.fileName}}`);
            isEncrypted = true;
          }
        }
        await putS3Data(file.data, file.url, file.type);
        const {
          applicationDocumentId,
          documentNumber
        } = await markUploadCompleted(token, classification.classification, file.documentId, classification.documentRequestId, isEncrypted);
        const rawName = _sliceInstanceProperty(_context2 = file.fileName.split(".")).call(_context2, 0, -1).join(".");
        const now = moment().toISOString();
        const newDocument = {
          applicationDocumentId,
          classificationType: classification.classification,
          comments: [],
          createdAt: now,
          description: classification.description,
          documentId: file.documentId,
          documentNumber: documentNumber,
          documentRequestId: classification.documentRequestId,
          documentStatus: "active",
          fileName: `${rawName}.pdf`,
          isSample: false,
          requestClassification: classification.classification,
          requestCreatedAt: "",
          requestStatus: "outstanding",
          requestUpdatedAt: "",
          requestedAt: "",
          sent: false,
          updatedAt: now
        };
        context.commit(ADD_DOCUMENTS_TO_CLASSIFICATION, {
          documentRequestId: newDocument.documentRequestId,
          documents: [newDocument]
        });
        newDocuments.push(newDocument);
        Amplitude.logEvent("Guest Upload - document uploaded to classification", {
          data: {
            classification: newDocument.documentRequestId,
            document: newDocument.documentId
          }
        });
      }
      if (newDocuments.length > 0) {
        if (notifyUser) showToast("success", "documentReceived");
        return {
          newDocuments,
          withError: false
        };
      }
    } catch (e) {
      var _e$responseJSON;
      if (notifyUser && ((_e$responseJSON = e.responseJSON) == null ? void 0 : _e$responseJSON.code) === "VirusDetected") {
        showToast("error", "virusDetected");
        return {
          withError: true
        };
      }
      if (notifyUser) Err.handle(e);
      return {
        withError: true
      };
    }
  }
};
export default actions;